import { EuiButton, EuiCallOut, EuiCheckbox, EuiFlexGroup, EuiFlexItem, EuiPanel, EuiPopover, EuiSpacer, EuiTab, EuiTabs } from '@elastic/eui';
import React, { useEffect, useMemo, useState } from 'react';
import './styles.css';
import { AbonoNormalScreen } from './abonoNormalScreen';
import { AbonoConModificacionScreen } from './abonoConModificacionScreen';


const tabs = [
    {
      id: 'normal',
      name: 'Normal',
      disabled: false,
    },
    {
      id: 'conModificaciones',
      name: 'Con Modificaciones',
      disabled: false,
    }
];

export const AbonosPartesScreen = (props)=>{

    const {partes, color, size, handleAbonar, handleAbonarConModificaciones, user} = props;

    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [selectedTabId, setSelectedTabId] = useState('normal');

    useEffect(()=>{},[])

    useEffect(()=>{if(!isPopoverOpen){setSelectedTabId('normal')}},[isPopoverOpen])

    const onRealizarAbono = ()=>{
        const _idsPartes = partes.map((p)=> p.idParte);
        handleAbonar(_idsPartes)
        setIsPopoverOpen(false)
    }

    const onRealizarAbonoConConfiguracion = (request) =>{
        const _idsPartes = partes.map((p)=> p.idParte);
        handleAbonarConModificaciones({...request,...{idsPartes:_idsPartes}})
        setIsPopoverOpen(false)
    }

    const nPartesFacturados = useMemo(()=>{
        return partes && partes.filter((f)=> f.facturado === true).length;
    },[partes])

    const nPartesNoFacturados = useMemo(()=>{
        return partes && partes.filter((f)=> f.facturado === false).length;
    },[partes])

    const nPartesConAbono = useMemo(()=>{
        return partes && partes.filter((f)=> f.abono === true).length;
    },[partes])

    const nPartes = useMemo(()=>{
        return partes && partes.length;
    },[partes])

    const btnAbono = useMemo(()=>{
        return <EuiButton 
                className='btn-abono-screen'
                onClick={()=>{setIsPopoverOpen(!isPopoverOpen)}}
                size={size} color={color} fill>
                {`Abonar (${nPartes})`}
                </EuiButton>
    },[setIsPopoverOpen,isPopoverOpen,partes])

    const onSelectedTabChanged = (id) => {
        setSelectedTabId(id);
    };

    const renderTabs =()=>{
        return tabs.map((tab, index) => (
            <EuiTab
            className={`tab-abonos ${tab.id === selectedTabId ? 'selected' : ''}`}
            key={index}
            onClick={() => onSelectedTabChanged(tab.id)}
            isSelected={tab.id === selectedTabId}
            disabled={tab.disabled}
            >
            {tab.name}
            </EuiTab>
        ));
    }


    const estadoPartes = useMemo(()=>{
        return {
            nPartes:nPartes,
            nPartesFacturados:nPartesFacturados,
            nPartesNoFacturados:nPartesNoFacturados,
            nPartesConAbono:nPartesConAbono
        }
    },[nPartes,nPartesFacturados,nPartesNoFacturados,nPartesConAbono])

      const getContent = useMemo(()=>{
        switch (selectedTabId) {
            case 'normal':
                return <AbonoNormalScreen handleAbonar={onRealizarAbono} estadoPartes={estadoPartes}/>
            case 'conModificaciones':
                return <AbonoConModificacionScreen handleAbonar={onRealizarAbonoConConfiguracion} estadoPartes={estadoPartes} user={user}/>
            default:
                break;
        }
      },[selectedTabId,estadoPartes,user])
      

    return (
        <EuiPopover
            button={btnAbono}
            isOpen={isPopoverOpen}
            closePopover={()=>{setIsPopoverOpen(false)}}
        >
            <EuiPanel className='panel-abono-screen'>

                <EuiTabs size="s" expand>
                    {renderTabs()}
                </EuiTabs>

                {getContent}
                
            </EuiPanel>
        </EuiPopover>
    );
}